module.exports = __webpack_public_path__ + "img/scissors.2d004011.svg";